import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import LegalWaiver from '../../../shared/project-info/web-project-info/LegalWaiver';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'justify',
    height: '90%',
    width: '60%',
    backgroundColor: 'var(--white)',
    padding: '32px',
    '&:focus-visible': {
      outlineColor: 'var(--primary)',
    },
  },
  goBackButton: {
    width: '150px',
    padding: '15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5px',
    backgroundColor: 'var(--primary)',
    color: 'white',
    alignSelf: 'center',
    marginTop: '20px',
    cursor: 'pointer',
  },
}));

export default function LegalModal({modalHandler, type, src}) {
  const classes = useStyles();

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={true}
        onClose={() => modalHandler(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={true}>
          <div className={classes.paper}>
            {type === 'iframe' ? (
              <iframe height={'100%'} src={src} title="Privacy Policy" />
            ) : (
              <LegalWaiver />
            )}
            <div
              className={classes.goBackButton}
              onClick={() => modalHandler(false)}>
              Close
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
